import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

type BillingInterval = "monthly" | "yearly";

interface PlanHeaderProps {
  billingInterval: BillingInterval;
  onBillingIntervalChange: (interval: BillingInterval) => void;
}

export function PlanHeader({ billingInterval, onBillingIntervalChange }: PlanHeaderProps) {
  return (
    <div className="text-center space-y-4" data-testid="plan-header">
      <h2 className="text-3xl font-bold">Choose Your Plan</h2>
      <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
        Select the perfect plan for your team. Upgrade, downgrade, or cancel anytime.
      </p>

      {/* Monthly/Yearly Toggle */}
      <div className="flex justify-center pt-4">
        <Tabs
          value={billingInterval}
          onValueChange={(value) => onBillingIntervalChange(value as BillingInterval)}
          className="inline-block"
        >
          <TabsList className="grid w-full grid-cols-2 p-1">
            <TabsTrigger
              value="monthly"
              className="px-8 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
            >
              Monthly
            </TabsTrigger>
            <TabsTrigger
              value="yearly"
              className="px-8 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
            >
              Yearly
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
    </div>
  );
}
